import { FC } from 'react'
import Modal from '../Modal'

interface Props {
  open: boolean
  close: () => void
}

const DonateModal: FC<Props> = ({ open, close }) => {
  return (
    <Modal open={open} close={close}>
      <div className="flex flex-col gap-y-2 text-center w-full">
        <h2 className="text-2xl font-bold text-kura px-8">Užívaš?</h2>
        <a href="https://donate.stripe.com/3cscQGc7f3NX5DW288" target="_blank" rel="noreferrer" className="button-primary bg-kura text-yellow-300">
          Podporiť
        </a>
        <p className="text-xs font-semibold text-kura px-8 mt-2">menej ako 50 centov sa nedá. kúp si rožok.</p>
      </div>
    </Modal>
  )
}

export default DonateModal
